import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useTicket from 'src/hooks/api/useTicket';
import { TicketClosedReason } from 'src/interfaces/api/Ticket';
import { FieldError } from 'react-hook-form';

interface Props {
  value?: number;
  formError?: FieldError;
  onChange: () => void;
  style?: any;
  className?: any;
}

const ClosedResponsabilitySelect = React.forwardRef<any, Props>(({ formError, value, onChange, ...props }, ref) => {
  const [closedReasons, setClosedReasons] = useState<TicketClosedReason[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const { getClosedReasons } = useTicket();

  useEffect(() => {
    getClosedReasons()
      .then((collection) => {
        setClosedReasons(collection.items);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <FormControl variant='outlined' error={!!formError} {...props} fullWidth>
      <Select native value={value} onChange={onChange}>
        <option value=''>Séléctionner la responsabilité de l'incident</option>
        {closedReasons.map((closedReason, key) => (
          <option key={key} value={closedReason.id}>
            {closedReason.label}
          </option>
        ))}
      </Select>
      {formError && <FormHelperText>{formError.message}</FormHelperText>}
    </FormControl>
  );
});

export default ClosedResponsabilitySelect;
